import EditIcon from "@mui/icons-material/Edit";
import SecurityIcon from "@mui/icons-material/Security";
import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import backArrow from "../../assets/icons/backArrow.svg";
import CustomLoader from "../../global/components/CustomLoader/CustomLoader";
import { selectIsVedazUser } from "../../redux/authSlice";
import history from "../../utils/history";
import { useAppSelector } from "../../utils/hooks";
import { theme } from "../../utils/styles";
import ConsentFormDialog from "../Shared/Dialogs/ConsentFormDialog/ConsentFormDialog";
import settingsStyles from "./Settings.styles";

const Settings = () => {
  const classes = settingsStyles;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openConsentDialog, setOpenConsentDialog] = useState<boolean>(false);
  const isVedazUser = useAppSelector(selectIsVedazUser);

  const getHeader = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { sm: "center", xs: "baseline" },
          width: "100%",
        }}
        pb={3}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.goBack()}
        >
          {isMobile ? (
            <img src={backArrow} height={"20px"} alt="Module not found..." />
          ) : (
            <img src={backArrow} height={"25px"} alt="Module not found..." />
          )}
        </Box>
        <Typography sx={classes.italicTypo}>{t("settings")}</Typography>
      </Box>
    );
  };

  const getSettingsContent = () => {
    return (
      <Box sx={classes.settingSection}>
        <Stack spacing={3}>
          <Box sx={classes.settingCard}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <SecurityIcon sx={classes.settingIcon} />
              <Box sx={{ flex: 1 }}>
                <Typography sx={classes.settingLabel}>
                  {t("vedazConsent")}
                </Typography>
                <Typography sx={classes.settingDescription}>
                  {t("vedazConsentDescription")}
                </Typography>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    sx={classes.settingValue}
                    onClick={() => setOpenConsentDialog(true)}
                  >
                    {isVedazUser ? t("consentGranted") : t("consentNotGranted")}
                    <EditIcon sx={{ fontSize: 16, ml: 1 }} />
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Box>
    );
  };

  const getSettings = () => {
    return (
      <>
        <Box sx={classes.mainContainer}>
          <Box sx={classes.mainBox}>
            <Box sx={classes.subBox}>
              <Container maxWidth="xl" sx={{ px: 1 }}>
                {getHeader()}
                {getSettingsContent()}
              </Container>
            </Box>
          </Box>
        </Box>
        <ConsentFormDialog
          open={openConsentDialog}
          handleClose={() => setOpenConsentDialog(false)}
          setIsLoading={setIsLoading}
          fromSettings={true}
        />
        <CustomLoader isLoading={isLoading} />
      </>
    );
  };
  return getSettings();
};

export default Settings;
